import { dataLayerPush } from 'src/helpers/gtm';

export const pushTopBannerClosed = () => {
  dataLayerPush({ event: 'move_to_app_continued_upper_web' });
};

export const pushTopBannerClicked = () => {
  dataLayerPush({ event: 'move_to_app_opened_upper_app' });
};

export const pushTopBannerShown = () => {
  dataLayerPush({ event: 'move_to_app_shown_upper' });
};
